/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionStateEnum = 'ACTIVE' | 'SUSPENDED' | 'TERMINATED' | 'CANCELLED' | 'EXPIRED' | 'INACTIVE' | 'NEEDS_REVIEW' | 'REJECTED';

export const SubscriptionStateEnum = {

    ACTIVE: 'ACTIVE' as SubscriptionStateEnum,

    SUSPENDED: 'SUSPENDED' as SubscriptionStateEnum,

    TERMINATED: 'TERMINATED' as SubscriptionStateEnum,

    CANCELLED: 'CANCELLED' as SubscriptionStateEnum,

    EXPIRED: 'EXPIRED' as SubscriptionStateEnum,

    INACTIVE: 'INACTIVE' as SubscriptionStateEnum,

    NEEDS_REVIEW: 'NEEDS_REVIEW' as SubscriptionStateEnum,

    REJECTED: 'REJECTED' as SubscriptionStateEnum
};

